module.exports = "/_next/static/resources/photo-3-86dd6891df51d905ea17672a82942513.jpg";